<template>
    <div class="table-responsive">
        <table class="table table-sm table-nowrap card-table">
            <thead>
            <tr>
                <th v-for="column in columns" :key="column.name">
                    <span class="text-muted sort_remove_tosort">
                        <b-checkbox v-if="column.checkbox"
                                    @change="bulkUpdate($event, column.name)">
                                    {{$t(column.label)}}
                        </b-checkbox>
                    </span>
                    <span v-if="sort == column.name">
                        <span class="fe fe-chevron-down" v-if="order > 0"></span>
                        <span class="fe fe-chevron-up" v-else></span>
                    </span>
                </th>
                <th></th>
            </tr>
            </thead>
            <tbody class="list" v-if="loading">
            <tr>
                <td :colspan="columns.length+1" class="orders-order text-center">
                    <div class="spinner-border text-primary" role="status">
                        <span class="sr-only">{{ $t('Loading') }}...</span>
                    </div>
                </td>
            </tr>
            </tbody>
            <tbody class="list" v-if="data && !data.length && !loading">
            <tr>
                <td :colspan="columns.length+1" class="orders-order text-center">{{ $t('Nothing yet') }}</td>
            </tr>
            </tbody>
            <tbody class="list" v-if="!loading && data">
            <template v-for="item in data">
                <tr v-if="!item.hidden" :class="[{'table-child--head pointer': item.children},{'is-active':previewed === item.resource}]" :key="item.id" @click="openChild(item)">
                    <td v-for="column in columns" :key="column.id" :width="column.width"
                        @click="column.link ? $router.push(column.link(item)) : null">
                        <span v-if="column.field" v-html="column.field(item)"></span>
                        <span v-else-if="column.checkbox && !item.children">
                            <b-checkbox :checked="column.value(item)"
                                        :disabled="column.disabled(item)"
                                        @change="updateItem($event, item, column.name)">
                            </b-checkbox>
                        </span>
                        <span v-else-if="column.checkbox && item.children">
                            <b-checkbox :indeterminate="column.children('indeterminate', item)"
                                        :checked="!column.disabled(item) ? column.children('determined', item) : false"
                                        :disabled="column.disabled(item)"
                                        @change="bulkUpdate($event, column.name, item.children)">
                            </b-checkbox>
                        </span>
                        <div v-if="column.subtitle" class="text-muted" v-html="column.subtitle(item)"></div>
                    </td>
                    <td class="text-right p-0">
                        <span v-if="item.children">
                            <button class="btn" v-if="previewed === item.resource">
                                <i class="fe fe-chevron-down"></i>
                            </button>
                            <button class="btn" v-else>
                                <i class="fe fe-chevron-right"></i>
                            </button>
                        </span>
                    </td>
                </tr>
                <template v-if="item.children && item.children.length">
                    <tr class="d-none" :class="{'d-table-row': previewed === item.resource}" :key="item.resource">
                        <td colspan="6" class="table-child--parent" style="padding:0!important;">
                            <table class="table table-child table-sm table-nowrap card-table border-top border-bottom">
                                <tbody class="list">
                                    <template v-for="child in item.children">
                                        <tr v-if="!child.hidden" :key="child._id">
                                            <td v-for="column in columns" :key="column.id" :width="column.width"
                                                @click="column.link ? $router.push(column.link(child)) : null">
                                                <span v-if="column.field" v-html="column.field(child)"></span>
                                                <span v-else-if="column.checkbox">
                                                    <b-checkbox :checked="!column.disabled(child) ? column.value(child) : false"
                                                                :disabled="column.disabled(child)"
                                                                @change="updateItem($event, child, column.name)">
                                                    </b-checkbox>
                                                </span>
                                                <span v-else>{{ child[column.name] }}</span>
                                                <div v-if="column.subtitle" class="text-muted" v-html="column.subtitle(child)"></div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </template>
            </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import Avatar from '@/components/Avatar.vue'
import Money from '@/components/Money.vue'
import ConfirmationModal from '@/components/ConfirmationModal.vue'
import { modalMixins } from '@/mixins/modal.js'

export default {
    props: ['data', 'columns', 'edit', 'bulkActions', 'onSort', 'loading', 'rowButtons', 'updateItem', 'bulkUpdate'],
    mixins: [modalMixins],
    components: {
        Avatar,
        Money,
        ConfirmationModal
    },
    data: function () {
        return {
            sort: 'createdAt',
            order: -1,
            selected: [],
            model: {},
            previewed: null
        }
    },
    methods: {
        openChild(item) {
            if (!item.children)
                return;
            this.previewed = item.resource !== this.previewed ? item.resource : null;
        }
    }
}
</script>

<style lang="scss" scoped>
.card-table thead th:first-child,
.card-table tbody td:first-child {
    width: 30%;
}

.table thead th,
.table tbody th,
.table tbody td {
    width: 11.66666%;
}

.table-child {
    &--parent {
        background: #fbfdff;
        &::v-deep .custom-control-input:disabled~.custom-control-label::before {
            background: transparent;
        }
    }
    &--head {
        &::v-deep .custom-control-input:disabled~.custom-control-label::before {
            background: transparent;
        }
        &.is-active {
            background: #edf2f9;
        }
    }

    &.card-table thead th:first-child,
    &.card-table tbody td:first-child {
        span {
            padding-left: 15px;
        }
    }
}

.custom-control {
    &::v-deep &-label {
        top: 4px;
    }
    &::v-deep &-label::before,
    &::v-deep &-label::after {
        top: 0;
    }
}

.table-responsive {
    height: calc(var(--calculated-vh, 1vh) * 100 - 370px);
    @media (max-width: 767px) {
        height: calc(var(--calculated-vh, 1vh) * 100 - 460px);
    }
}

thead tr:nth-child(1) th{
    position: sticky;
    top: 0;
    z-index: 10;
}
</style>
